export default __webpack_public_path__ + "static/media/follow-play.dafa89ed.webp";